import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type ClientFaqState, initialState } from './client-faq.state';

/**
 * Client FAQ slice (#735). Reducers are pure state transitions only; the loads
 * and the message to the CSM live in the saga, which dispatches these as it
 * progresses. The page itself only dispatches `csmMessageReset` and `pageLeft`.
 */
const slice = createSlice({
  name: 'clientFaq',
  initialState,
  reducers: {
    /**
     * The page left: a next visit starts from nothing rather than from this one's
     * FAQ, which a deep link would otherwise be checked against before the fresh
     * one arrives.
     */
    pageLeft: () => initialState,
    loadStarted: (state) => {
      state.loadStatus = 'loading';
    },
    loadSucceeded: (state, action: PayloadAction<Pick<ClientFaqState, 'categories' | 'csm'>>) => {
      state.categories = action.payload.categories;
      state.csm = action.payload.csm;
      state.loadStatus = 'loaded';
    },
    loadFailed: (state) => {
      state.loadStatus = 'failed';
    },

    csmMessageReset: (state) => {
      state.csmMessage = { status: 'idle', error: null };
    },
    csmMessageSending: (state) => {
      state.csmMessage = { status: 'sending', error: null };
    },
    csmMessageSent: (state) => {
      state.csmMessage = { status: 'sent', error: null };
    },
    csmMessageFailed: (state, action: PayloadAction<string>) => {
      state.csmMessage = { status: 'failed', error: action.payload };
    },
  },
});

export const clientFaqActions = slice.actions;
export const { csmMessageReset, pageLeft } = slice.actions;
export const clientFaqReducer = slice.reducer;
